import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TableDataColumn } from '@mri/types';

export interface ColumnManagementData {
  allColumns: TableDataColumn[];
  showedColumnKeys: string[];
}

@Component({
  selector: 'app-column-management',
  templateUrl: './column-management.component.html',
  styleUrls: ['./column-management.component.scss'],
})
export class ColumnManagementComponent {
  columns: (TableDataColumn & { checked: boolean })[];

  constructor(
    public dialogRef: MatDialogRef<ColumnManagementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ColumnManagementData
  ) {
    const showedColumnKeys = new Set(this.data.showedColumnKeys);

    const showedColumnsInOrder = this.data.showedColumnKeys
        .map(key => this.data.allColumns.find(c => c.key === key))
        .filter((c): c is TableDataColumn => !!c);

    const unselectedColumns = this.data.allColumns.filter(c => !showedColumnKeys.has(c.key));

    this.columns = [
        ...showedColumnsInOrder.map(c => ({...c, checked: true})),
        ...unselectedColumns.map(c => ({...c, checked: false}))
    ];
  }

  drop(event: CdkDragDrop<(TableDataColumn & { checked: boolean })[]>) {
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
  }

  onAccept(): void {
    this.dialogRef.close(this.columns);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
